import { render, staticRenderFns } from "./BackofficeDeleteVin.vue?vue&type=template&id=28a13c4d&"
import script from "./BackofficeDeleteVin.vue?vue&type=script&lang=js&"
export * from "./BackofficeDeleteVin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports